export const ISV_PLANS_URL = 'https://www.instoreview.com/planes'
export const ISV_INIT_URL = 'https://www.instoreview.com/'

export const SORIANA_AZURE_USER_TYPE = 'AZURE'
export const SORIANA_TRADITIONAL_USER_TYPE = 'TRADITIONAL'
